import React from 'react'
import CognitoUserManagement from './CognitoUserManagement'

import FormatCheckTextBox from '../../../../common/component/FormatCheckTextBox'
import Window from '../../../../common/Window'
import Loading from '../../../../common/component/Loading';

class CognitoUserEdit extends CognitoUserManagement {
  constructor(props) {
    super(props);
    this.state = {
      ...this.getInitialState(),
      isLoaded: false,
    };
  }
  getInitialState () {
    return {
      isNew: true,
      isLoaded: false,
      enabled: '',
      createdDateTime: '',
      updatedDateTime: '',
      status: '',
      id: '',
      email: '',
      name: '',
      emailNotification: 'True',
      prefectures: '',
      branch: '',
      administrator: '',
      isMember: 'true',
      approvalFlg: 'false',
      oldApprovalFlg: 'false',
      parentID: ''
    }
  }
  componentWillMount () {
    const {params} = this.props.match
    const id = params.id
    if (id) {
      this.loadUserDetail()
    } else {
      const initialState = this.getInitialState()
      this.setState(initialState)
      this.setState({isLoaded: true})
    }
  }
  changed (name, e) {
    this.setState({[name]: e.target.value})
  }
  handleRadioChange(isMemberValue, approvalFlgValue, oldApprovalFlgValue) {
    this.setState({'isMember': isMemberValue,
                   'approvalFlg': approvalFlgValue,
                   'oldApprovalFlg': oldApprovalFlgValue})
  }
  loadUserDetail () {
    const {params} = this.props.match
    const id = params.id
    const onSuccess = (cognitoUser) => {
      this.setState({
        isNew: false,
        isLoaded: true,
        enabled: cognitoUser.Enabled,
        createdDateTime: cognitoUser.UserCreateDate,
        updatedDateTime: cognitoUser.UserLastModifiedDate,
        status: cognitoUser.UserStatus,
        id: cognitoUser.Username,
        email: this.arrayGet(cognitoUser.UserAttributes, 'email'),
        name: this.arrayGet(cognitoUser.UserAttributes, 'custom:Name'),
        emailNotification: this.arrayGet(cognitoUser.UserAttributes, 'custom:emailNotification'),
        prefectures: this.arrayGet(cognitoUser.UserAttributes, 'custom:prefectures'),
        branch: this.arrayGet(cognitoUser.UserAttributes, 'custom:branch'),
        administrator: this.arrayGet(cognitoUser.UserAttributes, 'custom:administrator'),
        isMember: this.arrayGet(cognitoUser.UserAttributes, 'custom:isMember'),
        approvalFlg: this.arrayGet(cognitoUser.UserAttributes, 'custom:approvalFlg'),
        oldApprovalFlg: this.arrayGet(cognitoUser.UserAttributes, 'custom:approvalFlg'),
        parentID: this.arrayGet(cognitoUser.UserAttributes, 'custom:ParentID')
      })
    }
    this.getCognitoUser(id, onSuccess)
  }
  renderUserDetail (title, nameTitle, userDetail, isNew) {
    const actionTitle = isNew ? '新規登録' : '変更'
    const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/
    if(this.userRoleUrl == 'admin_user') {
      return (
        <fieldset>
          <legend>{title} - {actionTitle}</legend><br />
          <div className='control-group'><label className='control-label'>{nameTitle} <span className='required'>*</span></label>
            <div className='controls'><input type='text' name='name' className='span5' value={userDetail.name} autoComplete='false' onChange={e => this.changed('name', e)} /></div>
          </div>
          <div className='control-group'><label className='control-label'>メールアドレス <span className='required'>*</span></label>
            <div className='controls'>
              <FormatCheckTextBox className='span5' value={userDetail.email} autoComplete='false' onChange={e => this.changed('email', e)} pattern={emailPattern} message='正しいメールアドレスの形式で入力してください' />
            </div>
          </div>
          <div className='control-group'>
            <label className='control-label'>お知らせメール受信 <span className='required'>*</span></label>
            <div className='controls kw-radio'>
              <label htmlFor='Recieve' className='kw-pointer'><input type='radio' id='Recieve' name='RecieveType' checked={userDetail.emailNotification === 'true'} value='true' onChange={e => this.changed('emailNotification', e)} />受信する</label>
              <label htmlFor='NonRecieve' className='kw-pointer'><input type='radio' id='NonRecieve' name='RecieveType' checked={userDetail.emailNotification === 'false'} value='false' onChange={e => this.changed('emailNotification', e)} />受信しない</label>
            </div>
          </div>
        </fieldset>
      )
    } else if(this.userRoleUrl == 'company_user') {
      return (
        <fieldset>
          <legend>{title} - {actionTitle}</legend><br />
          <div className='control-group'><label className='control-label'>{nameTitle} <span className='required'>*</span></label>
            <div className='controls'><input type='text' name='name' className='span5' value={userDetail.name} autoComplete='false' onChange={e => this.changed('name', e)} /></div>
          </div>
          <div className='control-group'><label className='control-label'>企業ユーザーメールアドレス <span className='required'>*</span></label>
            <div className='controls'>
              <FormatCheckTextBox className='span5' value={userDetail.email} autoComplete='false' onChange={e => this.changed('email', e)} pattern={emailPattern} message='正しいメールアドレスの形式で入力してください' />
            </div>
          </div>
          <div className='control-group'>
            <label className='control-label'>お知らせメール受信 <span className='required'>*</span></label>
            <div className='controls kw-radio'>
              <label htmlFor='Recieve' className='kw-pointer'><input type='radio' id='Recieve' name='RecieveType' checked={userDetail.emailNotification === 'true'} value='true' onChange={e => this.changed('emailNotification', e)} />受信する</label>
              <label htmlFor='NonRecieve' className='kw-pointer'><input type='radio' id='NonRecieve' name='RecieveType' checked={userDetail.emailNotification === 'false'} value='false' onChange={e => this.changed('emailNotification', e)} />受信しない</label>
            </div>
          </div>
        </fieldset>
      )
    } else {
      return (
        <fieldset>
          <legend>{title} - {actionTitle}</legend><br />
          <div className='control-group'><label className='control-label'>{nameTitle} <span className='required'>*</span></label>
            <div className='controls'><input type='text' name='name' className='span5' value={userDetail.name} autoComplete='false' onChange={e => this.changed('name', e)} /></div>
          </div>
          <div className='control-group'>
            <label className='control-label'>会員/会員外 <span className='required'>*</span></label>
            <div className='controls kw-radio'>
              {userDetail.id !== '' && userDetail.approvalFlg && (
              <label htmlFor='NoApproval' className='kw-pointer'>
                <input type='radio' id='NoApproval' name='isMember' value='approval' checked={userDetail.approvalFlg === 'false' && userDetail.isMember === 'false'}
                 onChange={() => this.handleRadioChange('false', 'false', userDetail.oldApprovalFlg)} disabled={userDetail.approvalFlg === 'true' && userDetail.oldApprovalFlg === 'true'} />
                未承認
              </label>
              )}
              <label htmlFor='Member' className='kw-pointer'>
                <input type='radio' id='Member' name='isMember' value='true' checked={(userDetail.approvalFlg === 'true' || userDetail.approvalFlg === '') && (userDetail.isMember === 'true' || userDetail.isMember === 'True')} 
                 onChange={() => this.handleRadioChange('true', 'true', userDetail.oldApprovalFlg)} />
                会員
              </label>
              <label htmlFor='NonMember' className='kw-pointer'>
                <input type='radio' id='NonMember' name='isMember' value='false' checked={(userDetail.approvalFlg === 'true' || userDetail.approvalFlg === '') && (userDetail.isMember === 'false' || userDetail.isMember === '')} 
                 onChange={() => this.handleRadioChange('false', 'true', userDetail.oldApprovalFlg)} />
                会員外
              </label>
            </div>
          </div>
          <div className='control-group'><label className='control-label'>会社所在地都道府県名</label>
            <div className='controls'><input type='text' name='prefectures' className='span5' value={userDetail.prefectures} autoComplete='false' onChange={e => this.changed('prefectures', e)} /></div>
          </div>
          <div className='control-group'><label className='control-label'>支部名</label>
            <div className='controls'><input type='text' name='branch' className='span5' value={userDetail.branch} autoComplete='false' onChange={e => this.changed('branch', e)} /></div>
          </div>
          <div className='control-group'><label className='control-label'>企業管理者名</label>
            <div className='controls'><input type='text' name='administrator' className='span5' value={userDetail.administrator} autoComplete='false' onChange={e => this.changed('administrator', e)} /></div>
          </div>
          <div className='control-group'><label className='control-label'>企業管理者メールアドレス <span className='required'>*</span></label>
            <div className='controls'>
              <FormatCheckTextBox className='span5' value={userDetail.email} autoComplete='false' onChange={e => this.changed('email', e)} pattern={emailPattern} message='正しいメールアドレスの形式で入力してください' />
            </div>
          </div>
          <div className='control-group'>
            <label className='control-label'>お知らせメール受信 <span className='required'>*</span></label>
            <div className='controls kw-radio'>
              <label htmlFor='Recieve' className='kw-pointer'><input type='radio' id='Recieve' name='RecieveType' checked={userDetail.emailNotification === 'true'} value='true' onChange={e => this.changed('emailNotification', e)} />受信する</label>
              <label htmlFor='NonRecieve' className='kw-pointer'><input type='radio' id='NonRecieve' name='RecieveType' checked={userDetail.emailNotification === 'false'} value='false' onChange={e => this.changed('emailNotification', e)} />受信しない</label>
            </div>
          </div>
        </fieldset>
      )
    }
  }
  addUser (newUser) {
    newUser.name = newUser.name.trim()
    newUser.email = newUser.email.trim()
    if (newUser.name === '') {
      Window.alert(this.nameTitle + 'は必須です。')
      return false
    }
    if (newUser.email === '') {
      Window.alert('メールアドレスは必須です。')
      return false
    }
    const onSuccess = (res) => {
      if (res.body.User) {
        // console.log(res.body) //デバッグ時以外はコメントアウト
        Window.alert(this.userRoleName + '情報を登録しました', () => {
          let detailUrl = '/admin/' + this.userRoleUrl + '/detail/' + res.body.User.Username + '?temporaryPassword=' + res.body.temporaryPassword
          if (this.parentUserRoleUrl) {
            const {params} = this.props.match
            const parentID = params.parentID
            detailUrl = '/admin/' + this.userRoleUrl + '/detail/' + parentID + '/' + res.body.User.Username + '?temporaryPassword=' + res.body.temporaryPassword
          }
          this.props.history.push(detailUrl)
          Window.closeDialog()
        })
      } else {
        if (res.body.name == 'UsernameExistsException') {
          Window.alert('既に存在するメールアドレスです。')
          return false
        }
        // console.log(res) //デバッグ時以外はコメントアウト
        Window.alert('登録時にエラーが発生しました')
        return false
      }
    }
    this.addCognitoUser(newUser, onSuccess)
  }
  updateUser (updateUser) {
    updateUser.name = updateUser.name.trim()
    updateUser.email = updateUser.email.trim()
    if (updateUser.name === '') {
      Window.alert(this.nameTitle + 'は必須です。')
      return false
    }
    if (updateUser.email === '') {
      Window.alert('メールアドレスは必須です。')
      return false
    }
    let detailUrl = '/admin/' + this.userRoleUrl + '/detail/' + updateUser.id
    if (this.parentUserRoleUrl) {
      const {params} = this.props.match
      const parentID = params.parentID
      detailUrl = '/admin/' + this.userRoleUrl + '/detail/' + parentID + '/' + updateUser.id
    }
    const onSuccess = (res) => {
      if (res.body && !res.body.hasOwnProperty('code')) {
        Window.alert(this.userRoleName + '情報を更新しました', () => {
          this.props.history.push(detailUrl)
          Window.closeDialog()
        })
      } else {
        // console.log(res) //デバッグ時以外はコメントアウト
        Window.alert('更新時にエラーが発生しました')
        return false
      }
    }
    this.updateCognitoUser(updateUser, onSuccess)
  }
  onPageMenuClicked (name) {
    const id = this.state.id

    let backUrl
    if (this.state.isNew) {
      backUrl = '/admin/' + this.userRoleUrl + '/'
    } else {
      backUrl = '/admin/' + this.userRoleUrl + '/detail/' + id
    }

    if (this.parentUserRoleUrl) {
      const {params} = this.props.match
      const parentID = params.parentID
      if (this.state.isNew) {
        backUrl = '/admin/' + this.parentUserRoleUrl + '/detail/' + parentID
      } else {
        backUrl = '/admin/' + this.userRoleUrl + '/detail/' + parentID + '/' + id
      }
    }

    switch (name) {
      case 'back':
        this.props.history.push(backUrl)
        break
      default:
        break
    }
  }
  onFormButtonClicked (name, e) {
    e.preventDefault()
    const adminUser = this.state
    let backUrl
    if (this.state.isNew) {
      backUrl = '/admin/' + this.userRoleUrl + '/'
    } else {
      backUrl = '/admin/' + this.userRoleUrl + '/detail/' + adminUser.id
    }

    if (this.parentUserRoleUrl) {
      const {params} = this.props.match
      const parentID = params.parentID
      if (this.state.isNew) {
        backUrl = '/admin/' + this.parentUserRoleUrl + '/detail/' + parentID
      } else {
        backUrl = '/admin/' + this.userRoleUrl + '/detail/' + parentID + '/' + adminUser.id
      }
    }
    switch (name) {
      case 'save':
        if (this.state.isNew) {
          const {params} = this.props.match
          if (params.parentID) {
            const parentID = params.parentID
            adminUser.parentID = parentID
          }
          this.addUser(adminUser)
        } else {
          this.updateUser(adminUser)
        }
        break
      case 'cancel':
        this.props.history.push(backUrl)
        break
      default:
        break
    }
  }
  render () {
    if (!this.state.isLoaded) {
      return <Loading />;
    }
    const userDetail = this.renderUserDetail(this.userRoleName + '情報', this.nameTitle, this.state, this.state.isNew)
    const title = this.state.isNew ? '新規登録' : '変更'
    return (
      <div>
        <section className='nav-page'>
          <div className='container'>
            <div className='row'>
              <div className='span7'>
                <header className='page-header'>
                  <h3>{this.userRoleName}情報 - {title}<br /><small>こちらで{this.userRoleName}の情報を{title}できます。</small></h3>
                </header>
              </div>
              <div className='span9'>
                <ul className='nav nav-pills'>
                  <li className='kw-btn-area'><button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back')}><i className='icon-arrow-left icon-large' /><span>戻る</span></button></li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className='page container'>
          <form className='form-horizontal' method='post'>
            <div className='alert alert-block alert-info'>
              <p>必要な情報を入力して最後に「保存」ボタンを押してください。「<span className='required'>*</span>」マークは必須項目です。</p>
            </div>
            {userDetail}
            <footer id='submit-actions' className='form-actions'>
              <button className='btn btn-primary' onClick={(e) => this.onFormButtonClicked('save', e)} >保存</button>
              <button className='btn btn-default' onClick={(e) => this.onFormButtonClicked('cancel', e)}>キャンセル</button>
            </footer>
          </form>
        </section>
      </div>
    )
  }
}

export default CognitoUserEdit



// WEBPACK FOOTER //
// ./src/admin/pages/secure/abstract/CognitoUserEdit.js